import { createRoot } from 'react-dom/client'
import config from '../../based.js'
import { Provider as BasedClientProvider, recordBasedClient } from '@based'
import { App } from './pages/App.js'
import based from '@based/sdk/client'
import './global.css'

const e = 'Unsupported browser'
if (
  !('Blob' in window) ||
  !Blob.prototype.arrayBuffer ||
  typeof crypto === 'undefined' ||
  typeof crypto.randomUUID !== 'function' ||
  typeof structuredClone !== 'function' ||
  typeof Array.prototype.at !== 'function'
) {
  if (!('url' in config)) {
    dispatchEvent(new ErrorEvent('error', { message: e }))
    throw Error(e)
  }
}

const client = based(config)
recordBasedClient(client)
const rootElement = document.getElementById('root')!
const root = createRoot(rootElement)

root.render(
  <BasedClientProvider client={client}>
    <App />
  </BasedClientProvider>,
)
